import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import type { AppConfig } from './types';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getResolution(ratio: string): [number, number] {
  switch (ratio) {
    case '9:16': return [1080, 1920];
    case '1:1': return [1080, 1080];
    case '4:5': return [1080, 1350];
    default: return [1920, 1080];
  }
}

export function parseDuration(d: string): number {
  const parts = d.split(':').map(Number);
  if (parts.length === 2) return (parts[0] || 0) * 60 + (parts[1] || 0);
  return 10;
}

export function getPreviewAspectClass(ratio: string) {
  switch (ratio) {
    case "9:16": return "aspect-[9/16]";
    case "1:1": return "aspect-square";
    case "4:5": return "aspect-[4/5]";
    case "16:9":
    default: return "aspect-video";
  }
}


export function getEffectiveDuration(config: Pick<AppConfig, 'audio' | 'durationStr'>): number {
  const hasVO = !!config.audio.voiceoverUrl && !!config.audio.voiceoverDuration;
  const hasMusic = !!config.audio.musicUrl && !!config.audio.musicDuration;
  
  if (hasVO && hasMusic) {
    // Both present: voiceover dictates length, adding 2s padding at start and 2s padding at end for fade
    return (config.audio.voiceoverDuration || 0) + 4;
  }
  
  if (hasVO) {
    return config.audio.voiceoverDuration || 0;
  }
  
  if (hasMusic) {
    return config.audio.musicDuration || 0;
  }
  
  return parseDuration(config.durationStr);
}
